module.exports = __webpack_public_path__ + "img/Star Wars poster.acdd5f9a.png";